import { render, staticRenderFns } from "./ModelIndex.vue?vue&type=template&id=50f34519&"
import script from "./ModelIndex.vue?vue&type=script&lang=js&"
export * from "./ModelIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports